import { Component } from "@angular/core";
import { faMap } from '@fortawesome/free-solid-svg-icons';
import { faFacebook} from '@fortawesome/free-brands-svg-icons';

@Component({
    selector: 'app-footer',
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    standalone: false
})
export class FooterComponent {
    
    public year = new Date().getFullYear();
    public faMap = faMap;
    public faFacebook = faFacebook;

    constructor() {}

    open(url: string) {
        var element = document.createElement('a');
        element.href = url;
        element.target = '_blank';
        element.click();
        element.remove();
    }
}